import { S, ui, save } from "../../app/store.js";
import { can } from "../../services/access.js";
import { esc } from "../../domain/format.js";
import { log } from "../../services/audit.js";
import { render } from "../../app/shell.js";
export function employeeProfile() {
  const e = S.employees.find((e) => e.id === ui.editEmployee);
  if (!e || !can("hr.salary")) return "";
  return `<form id="employee-profile" class="work-log-form"><h2>${esc(e.name)} · Government registrations</h2><div class="form">${[
    ["tin", "TIN"],
    ["sss", "SSS number"],
    ["philhealth", "PhilHealth PIN"],
    ["pagibig", "Pag-IBIG MID"],
  ]
    .map(
      ([key, label]) =>
        `<label>${label}<input name="${key}" value="${esc(e[key] || "")}" maxlength="30" autocomplete="off"></label>`,
    )
    .join(
      "",
    )}</div>${ui.employeeError ? `<p class="err">${esc(ui.employeeError)}</p>` : ""}<div class="row"><button class="pri" type="submit">Save registrations</button><button type="button" data-employee-close>Cancel</button></div></form>`;
}
export function installEmployeeEvents() {
  document.addEventListener("click", (event) => {
    const b = event.target.closest("button");
    if (b?.dataset.employeeEdit) {
      ui.editEmployee = b.dataset.employeeEdit;
      ui.employeeError = "";
      render();
    }
    if (b?.hasAttribute("data-employee-close")) {
      ui.editEmployee = null;
      render();
    }
  });
  document.addEventListener("submit", (event) => {
    if (event.target.id !== "employee-profile") return;
    event.preventDefault();
    if (!can("hr.salary")) return;
    const values = Object.fromEntries(new FormData(event.target)),
      digits = (s) => s.replace(/\D/g, "");
    for (const [key, length] of [
      ["sss", 10],
      ["philhealth", 12],
      ["pagibig", 12],
    ])
      if (values[key] && digits(values[key]).length !== length) {
        ui.employeeError = `${key === "sss" ? "SSS" : key === "philhealth" ? "PhilHealth" : "Pag-IBIG"} must have ${length} digits.`;
        return render();
      }
    if (values.tin && !/^\d{3}-?\d{3}-?\d{3}(-?\d{3,5})?$/.test(values.tin)) {
      ui.employeeError = "Enter a valid TIN.";
      return render();
    }
    const e = S.employees.find((e) => e.id === ui.editEmployee);
    Object.assign(e, values);
    log("Updated employee registrations", e.id);
    ui.editEmployee = null;
    save();
    render();
  });
}
